import { Button } from "@minuthq/meatball-ui-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { ErrorPage } from "src/ui/error-page/error-page"
import { PageLayout } from "src/ui/page-layout/page-layout"
import z from "zod"

import { SetNewPwForm } from "./-set-new-pw-form"

const searchSchema = z.object({
  token: z.string(),
})

export const Route = createFileRoute("/password/reset/set-new-password")({
  component: SetNewPassword,
  validateSearch: searchSchema,
  errorComponent: SetNewPasswordLinkError,
})

function SetNewPassword() {
  const { token } = Route.useSearch()
  const { tPlaceholder } = useTranslate()

  return (
    <PageLayout
      title={tPlaceholder("Choose a new password")}
      description={tPlaceholder(
        "To reset your current password, enter a new password below."
      )}
      footer={<Footer />}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      <SetNewPwForm token={token} />
    </PageLayout>
  )
}

function Footer() {
  const navigate = useNavigate()
  const { tPlaceholder } = useTranslate()

  return (
    <Button
      variant="minimal"
      color="neutral"
      size="small"
      onClick={() => {
        void navigate({ to: "/login" })
      }}
    >
      {tPlaceholder("Return to sign in")}
    </Button>
  )
}

function SetNewPasswordLinkError() {
  const { tPlaceholder } = useTranslate()

  return (
    <ErrorPage
      title={tPlaceholder("Invalid reset link")}
      description={tPlaceholder(
        "This password reset link is missing required information. Request a new one from the sign-in page."
      )}
    />
  )
}
